import { createSelector } from 'reselect';
const getState = (state) => state.mainReport;
export const selectCompletedWorkConfirmationsPending = createSelector(getState, (state) => state.completedWorkConfirmationsPending);
export const selectCompletedWorkData = createSelector(getState, (state) => state.completedWork);
export const selectCompletedWorkPending = createSelector(getState, (state) => state.completedWorkPending);
export const selectMainReport = createSelector(getState, (state) => state.mainReport);
export const selectWorkDays = createSelector(getState, (state) => state.workDays);
